module.exports = __webpack_public_path__ + "static/media/amex.bdf8942c.svg";